import React, { useEffect, useState } from 'react'
import './shopping-cart-icon.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';

const ShoppingCartIcon = ({ cart }) => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ itemCount, setItemCount ] = useState(0);

    useEffect(() => {
        if (!cart) return;
        setItemCount(Object.values(cart).reduce((acc, cur) => acc + cur.quantity, 0))
    }, [cart])

    return (
        <div className={`shopping-cart-icon ${screenSize}`}>
            <FontAwesomeIcon 
                className='icon'
                icon={faShoppingCart} 
                size="xl" 
            />
            <div className='count-div'>
                <div className='count-circle'>
                    {itemCount}
                </div>
            </div>
        </div>
    )
}

export default ShoppingCartIcon